// src/pages/StudentsEdit.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const StudentsEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [student, setStudent] = useState(null);
  const [form, setForm] = useState({
    school_no: "",
    first_name: "",
    last_name: "",
    class_name: "",
    branch: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/students/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setStudent(data);
        setForm({
          school_no: data.school_no || "",
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          class_name: data.class_name || "",
          branch: data.branch || "",
        });
      } catch (err) {
        console.error("❌ Öğrenci yüklenemedi:", err);
        toast.error("Öğrenci verisi alınamadı.");
      } finally {
        setLoading(false);
      }
    };
    fetchStudent();
  }, [id]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("admin_token");
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/students/${id}`,
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Öğrenci başarıyla güncellendi.");
      navigate(-1);
    } catch (err) {
      console.error("❌ Güncelleme hatası:", err);
      toast.error("Güncelleme sırasında hata oluştu.");
    }
  };

  if (loading) return <p>Yükleniyor…</p>;
  if (!student) return <p>Öğrenci bulunamadı.</p>;

  const cdnBase = process.env.REACT_APP_API_BASE_URL.replace("/api", "");

  return (
    <div className="container py-3">
      <div className="card mx-auto" style={{ maxWidth: 800 }}>
        <div className="card-body">
          <h2 className="card-title mb-4">Öğrenci Düzenle</h2>

          {/* Düzenleme Formu */}
          <form onSubmit={handleSubmit} className="mb-5">
            <div className="mb-3">
              <label className="form-label">Okul No</label>
              <input
                name="school_no"
                value={form.school_no}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Ad</label>
              <input
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Soyad</label>
              <input
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Sınıf</label>
              <input
                name="class_name"
                value={form.class_name}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Şube</label>
              <input
                name="branch"
                value={form.branch}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                Kaydet
              </button>
            </div>
          </form>

          {/* Optik form görüntüleri – FORMUN ALTINDA */}
          {Array.isArray(student.optical_forms) &&
            student.optical_forms.length > 0 && (
              <div>
                {student.optical_forms.map((fp) => (
                  <img
                    key={fp}
                    src={`${cdnBase}/${fp}`}
                    alt="Optik Form"
                    className="img-fluid mb-3"
                    style={{
                      maxWidth: "100%",
                      display: "block",
                      margin: "1rem auto",
                    }}
                  />
                ))}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default StudentsEdit;
